import React from 'react';

import { Badge, Callout, Step } from './shared';

const ConnectEmail: React.FC = () => (
  <div>
    <h2 className="text-2xl font-bold mb-4">Connect Email</h2>
    <p className="text-sm text-base-content/70 mb-5 leading-relaxed">
      Email is an <strong>outbound-only</strong> notification channel — sync failures, the daily risk digest, the weekly
      summary, and proactive insights can be delivered to your inbox. Unlike Slack or Telegram, you can&apos;t chat with
      the AI assistant over email.
    </p>

    <h3 className="font-semibold mb-3">Step-by-step</h3>
    <div className="space-y-3 mb-6">
      <Step n={1}>
        Open <strong>Integrations</strong> and locate the <strong>Email</strong> card.
      </Step>
      <Step n={2}>
        Click <strong>Verify email</strong>. There&apos;s nothing to type — MFlow sends the verification link to your
        account&apos;s own sign-in email address, since that&apos;s the only address you should be able to register.
      </Step>
      <Step n={3}>
        Open the email in your inbox and click the confirmation link. This proves you own the address before MFlow
        starts sending anything to it.
      </Step>
      <Step n={4}>
        Return to MFlow. The card updates to <Badge color="badge-success">Connected</Badge>. If you were still on the
        Integrations page, it picks this up automatically within a few seconds; otherwise refresh.
      </Step>
    </div>

    <Callout type="warning">
      The verification link expires after <strong>10 minutes</strong>. If it expires, click{' '}
      <strong>Verify email</strong> again to get a new one.
    </Callout>

    <p className="text-sm text-base-content/70 mt-5 leading-relaxed">
      Once connected, Email behaves like any other channel in <strong>Settings</strong> — enable or disable it, and set
      its priority against Slack and Telegram.
    </p>

    <h3 className="font-semibold mt-5 mb-3">Disconnecting Email</h3>
    <p className="text-sm text-base-content/70 leading-relaxed">
      Click <strong>Disconnect</strong> on the Email card. No further notifications are sent to that address, and
      you&apos;ll need to verify it again to reconnect.
    </p>
  </div>
);

export default ConnectEmail;
